
import React from 'react';
import { LoadingSpinner } from './LoadingSpinner';

interface PageLoadingSpinnerProps {
  message?: string;
}

export const PageLoadingSpinner: React.FC<PageLoadingSpinnerProps> = ({ 
  message = 'Загрузка страницы...'
}) => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-4">
      <LoadingSpinner size="lg" />
      <p className="mt-4 text-lg text-muted-foreground">{message}</p>
    </div>
  );
};

export default PageLoadingSpinner;
